const NotAllowed = () => {
    return <div>Sem permissão de acesso</div>
}

export default NotAllowed
